import './codigoRegraInfoTooltip.css';
import { useState, useEffect  } from "react";
import { IDocumentoAdicionado, IRegras } from "../../interfaces/IRegras";
import { Modal } from 'react-bootstrap-v5';
import clsx from "clsx";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { IDocumentos } from "../../interfaces/IDocumentos";
import RegrasService from '../../services/RegrasService';

function RegrasModal({ toggleModal, show, regra, title, documentos }: { toggleModal: (recarregarInformacoes?: boolean) => void, show: boolean, regra: IRegras, title: string, documentos: IDocumentos[] }) {

  const [documentosAdicionados, setDocumentosAdicionados] = useState<IDocumentos[]>([]);
  const [documentosVisualizacao, setDocumentosVisualizacao] = useState<IDocumentos[]>([]);
  const [documentoAdicionadoSelecionado, setDocumentoAdicionadoSelecionado] = useState<IDocumentos>();
  const [documentoVisualizacaoSelecionado, setDocumentoVisualizacaoSelecionado] = useState<IDocumentos>();
  const [pesquisa, setPesquisa] = useState<string>('');
  const regraSchema = Yup.object().shape({
    nome: Yup.string().max(50, 'Máximo 50 caracteres').required('Nome é obrigatório'),
    codigo: Yup.string().max(50, 'Máximo 50 caracteres').required('Código é obrigatório'),
    descricao: Yup.string().max(50, 'Máximo 50 caracteres').required('Descrição é obrigatório')
  })
  const formInitialValues: IRegras = {
    id: 0,
    codigo: '',
    nome: '',
    descricao: '',
    documentos: []
  };
  const formik = useFormik({
    initialValues: formInitialValues,
    validationSchema: regraSchema,
    onSubmit: async (regra, { setSubmitting }) => {
      function funcaoSucesso() {
        setSubmitting(false);
        toggleModal(true);
      }

      regra.documentos = documentosAdicionados.map(x => x as IDocumentoAdicionado);
  
      if ((regra?.id ?? 0) === 0) {
        await RegrasService.criar(regra, funcaoSucesso, 'Regra foi adicionada com sucesso');
      } else {
        await RegrasService.atualizar(regra, funcaoSucesso, 'Regra foi editado com sucesso');
      }
    }
  })

  useEffect(() => {
    formik.setValues(regra);

    !regra.nome && formik.setFieldTouched('nome', false);
    !regra.codigo && formik.setFieldTouched('codigo', false);
    !regra.descricao && formik.setFieldTouched('descricao', false);

    const documentosAdicionadosTratados = documentos.filter(x => regra.documentos?.find(p => x.id === p.documentoID) !== undefined) ?? [];
    const documentosVisualizacaoTratados = documentos.filter(x => documentosAdicionadosTratados?.find(p => x.id === p.id) === undefined) ?? [];

    setDocumentosAdicionados(documentosAdicionadosTratados);
    setDocumentosVisualizacao(documentosVisualizacaoTratados);
    setDocumentoAdicionadoSelecionado(undefined);
    setDocumentoVisualizacaoSelecionado(undefined);

    //eslint-disable-next-line
  }, [regra]);

  useEffect(() => {
    if (pesquisa === '' || pesquisa === null || pesquisa === undefined) {
      setDocumentosVisualizacao(documentos);
      return;
    }
    
    const documentosPesquisados = documentos.filter(e => (e.nome ?? "").toLowerCase().indexOf(pesquisa?.toLowerCase()) >= 0);

    setDocumentosVisualizacao(documentosPesquisados);
    setDocumentoVisualizacaoSelecionado(undefined);

  //eslint-disable-next-line
  }, [pesquisa]);

  return <Modal size='lg' centered={true} show={show} onHide={() => toggleModal()}>
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title titulo-modal">{title}</h5>
        <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
          <i onClick={() => toggleModal()} className="fas fa-times" style={{ color: '#5E6397' }}/>
        </div>
      </div>
      <div className="modal-body">
        <form className="row g-3">
          <div className="col-md-12">
            <label htmlFor="form-nome" className="form-label required">Nome da Regra</label>
            <input {...formik.getFieldProps('nome')} placeholder="Ex: Validar razão social" type="text" className={clsx(
              'form-control',
              {
                'is-invalid': formik.touched.nome && formik.errors.nome,
              },
              {
                'is-valid': formik.touched.nome && !formik.errors.nome,
              }
              )} id="form-nome" />
          </div>

          <div className="col-md-6">
            <label htmlFor="form-descricao" className="form-label mt-5">Descrição da Regra</label>
            <input {...formik.getFieldProps('descricao')} placeholder="Ex: Validar razão social" type="text" className={clsx(
              'form-control',
              {
                'is-invalid': formik.touched.descricao && formik.errors.descricao,
              },
              {
                'is-valid': formik.touched.descricao && !formik.errors.descricao,
              }
              )} id="form-descricao" />
          </div>

          <div className="col-md-6">
            <div data-tooltip="Esse código é fornecido pelo back-end ou desenvolvedor" data-tooltip-persistent>
            <label htmlFor="form-codigo" className="form-label mt-5">
              Código da Regra
              <i style={{color: '#66D4C7', marginLeft: '3px'}} className="bi bi-info-circle" ></i>
            </label>
            </div>
            <input {...formik.getFieldProps('codigo')} placeholder="Ex: regra_01" type="text" className={clsx(
              'form-control',
              {
                'is-invalid': formik.touched.codigo && formik.errors.codigo,
              },
              {
                'is-valid': formik.touched.codigo && !formik.errors.codigo,
              }
              )} id="form-codigo" />
          </div>
        </form>
        
        <div className="row mt-3">
        <div className="col-md-5 ms-5" style={{ border: '1px solid #DFDFDF', textAlign: 'left', borderRadius: '10px', padding: '0', margin: '0' }}>
          <h1 className="azul-agriholmes mt-5 mb-5 padding-regras-adicionadas">Documentos Adicionados</h1>
          {
            documentosAdicionados.map((x, index) => <p key={index} onClick={() => {
              if (documentoAdicionadoSelecionado?.id === x.id) {
                setDocumentoAdicionadoSelecionado(undefined);
                return;
              }

              setDocumentoAdicionadoSelecionado(x);
              setDocumentoVisualizacaoSelecionado(undefined);
            }} className={`parametrizacao-item ${documentoAdicionadoSelecionado?.id === x.id && 'parametrizacao-item-selecionado'}`}>{x.nome}</p>)
          }
        </div>
        <div className="col-md-1 align-items-center ms-1 mx-1" style={{ padding: '0', margin: '0', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <div className='align-items-center py-1'>
            <button disabled={documentoVisualizacaoSelecionado == null} onClick={() => {
              const novasRegras = documentos.filter(r => r.id !== documentoVisualizacaoSelecionado?.id);
              let novasRegrasAdicionadas = documentosAdicionados;

              if (documentoVisualizacaoSelecionado) {
                novasRegrasAdicionadas.push(documentoVisualizacaoSelecionado);
              }
              novasRegrasAdicionadas = novasRegrasAdicionadas.sort((a, b) => (a.nome ?? "") > (b.nome ?? "") ? -1 : 1);

              setDocumentosVisualizacao(novasRegras);
              setDocumentosAdicionados(novasRegrasAdicionadas);
            }} className='btn btn-sm btn-primario'>
              <i className="text-white fa fa-arrow-left"></i>
            </button>
          </div>
          <div className='align-items-center py-1'>
            <button disabled={documentoAdicionadoSelecionado == null} onClick={() => {
              const novasRegrasAdicionadas = documentosAdicionados.filter(r => r.id !== documentoAdicionadoSelecionado?.id);
              let novasRegras = documentos;

              if (documentoAdicionadoSelecionado) {
                novasRegras.push(documentoAdicionadoSelecionado);
              }
              novasRegras = novasRegras.sort((a, b) => (a.nome ?? "") > (b.nome ?? "") ? -1 : 1);

              setDocumentosVisualizacao(novasRegras);
              setDocumentosAdicionados(novasRegrasAdicionadas);
            }} className='btn btn-sm btn-primario'>
              <i className="text-white fa fa-arrow-right"/>
            </button>
          </div>
        </div>
        <div className="col-md-5" style={{ border: '1px solid #DFDFDF', textAlign: 'left', borderRadius: '10px'}}>
          <h1 className="azul-agriholmes mt-5 mb-5 padding-regras-adicionadas">Lista de Documentos</h1>
          <div style={{border: '1px solid #DDD', borderRadius: '10px', padding: '10px'}}>
            <input onChange={(e) => setPesquisa(e.target.value)} placeholder="Digite Algo" id="pesquisa-eventos" style={{border: 'none', outline: 'none', width: '90%' }}/>
            <button style={{border: 'none', outline: 'none', backgroundColor: 'transparent'}} type="submit"><i className="bi bi-search"/></button>
          </div>
          <div style={{overflow: 'auto', minHeight: '200px', maxHeight: '200px'}} onLoad={() => setPesquisa('')}>

          {
            documentosVisualizacao.map((x, index) => <p key={index} onClick={() => {
              if (documentoVisualizacaoSelecionado?.id === x.id) {
                setDocumentoVisualizacaoSelecionado(undefined);
                return;
              }

              setDocumentoVisualizacaoSelecionado(x);
              setDocumentoAdicionadoSelecionado(undefined);
            }} className={`pt-2 pb-2 parametrizacao-item ${documentoVisualizacaoSelecionado?.id === x.id ? 'parametrizacao-item-selecionado' : ''}`}>{x.nome}</p>)
          }
          {
            documentosVisualizacao.length === 0 && <h1 className="mt-5 ms-5" style={{fontSize: '1.5em', fontWeight: 'normal'}}>Não foi encontrado nenhum Documento </h1>
          }
          </div>
        </div>
        </div>
      </div>
      <div className="modal-footer" style={{ margin: '0 auto' }}>
        <button disabled={formik.isSubmitting} onClick={() => toggleModal(false)} type="button" className="btn btn-modal-cancelar me-5"> CANCELAR </button>
        <button disabled={formik.isSubmitting || !formik.isValid} onClick={async () => await formik.submitForm()} type="button" className="btn btn-primario ms-5">
          { !formik.isSubmitting && ((regra?.id ?? 0) === 0 ? 'ADICIONAR' : 'EDITAR') }
          {
            formik.isSubmitting && (
            <span className='indicator-progress' style={{ display: 'block' }}>
              Salvando...
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span>
          )}
        </button>
      </div>
    </div>
  </Modal>
}

export default RegrasModal;